import { css, html, LitElement, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { StoreController } from "./controller.store.js";
import { ReadingBeePasscode } from "./component.passcode.js";
import { appStore } from "./store.js";
import { globalStyles } from "./styles.global.js";
import "./component.passcode.js";

@customElement("reading-bee-instructor-gate")
export class ReadingBeeInstructorGate extends LitElement {
  static override styles = [
    globalStyles,
    css`
      :host {
        display: contents;
      }

      slot {
        display: contents;
      }

      .gate {
        min-height: 60dvh;
        width: 100%;
        display: grid;
        place-items: center;
      }
    `,
  ];

  constructor() {
    super();
    new StoreController(this);
  }

  override render(): TemplateResult {
    if (!appStore.needsInstructorUnlock()) {
      return html`
        <slot></slot>
      `;
    }
    return html`
      <div class="gate">
        <reading-bee-passcode
          title="Enter passcode"
          hint="Enter the instructor passcode"
          recoverable
          @complete=${this.onUnlock}></reading-bee-passcode>
      </div>
    `;
  }

  private padFrom(event: Event): ReadingBeePasscode {
    return event.currentTarget as ReadingBeePasscode;
  }

  private onUnlock = (event: Event): void => {
    const value = (event as CustomEvent<{ value: string }>).detail.value;
    if (!appStore.verifyPasscode(value)) {
      this.padFrom(event).shake();
      return;
    }
    appStore.unlockInstructorSession();
  };
}
